import { connect } from 'react-redux'
import * as actions from '../BreakOutMode/actions'
import SeminarMode from './SeminarMode'

const mapStateToProps = (state, ownProps) => {
  return {
    main: state.main
  }
}

const mapDispatchToProps = (dispatch) => (
  {
    updateHear: (group, hear) => dispatch(actions.updateHear(group, hear)),
    initGroupUser: (value) => dispatch(actions.initGroupUser(value)),
    addGroupUser: (value) => dispatch(actions.addGroupUser(value)),
    deleteGroupUser: (value) => dispatch(actions.deleteGroupUser(value)),
    updateGroupUser: (value) => dispatch(actions.updateGroupUser(value)),
    initTableUser: (value) => dispatch(actions.initTableUser(value)),
    addTableUser: (value) => dispatch(actions.addTableUser(value)),
    deleteTableUser: (value) => dispatch(actions.deleteTableUser(value)),
    updateTableUser: (value) => dispatch(actions.updateTableUser(value)),
    initRaiseUser: (value) => dispatch(actions.initRaiseUser(value)),
    addRaiseUser: (value) => dispatch(actions.addRaiseUser(value)),
    deleteRaiseUser: (value) => dispatch(actions.deleteRaiseUser(value)),
    updateRaiseUser: (value) => dispatch(actions.updateRaiseUser(value)),
    initRemoteUser: (value) => dispatch(actions.initRemoteUser(value)),
    addRemoteUser: (value) => dispatch(actions.addRemoteUser(value)),
    deleteRemoteUser: (value) => dispatch(actions.deleteRemoteUser(value)),
    updateRemoteUser: (value) => dispatch(actions.updateRemoteUser(value)),
    updateStream: (value) => dispatch(actions.updateStream(value)),
    addRemoteVideoUser: (value) => dispatch(actions.addRemoteVideoUser(value)),
    deleteRemoteVideoUser: (value) => dispatch(actions.deleteRemoteVideoUser(value)),
    videoReset: (value) => dispatch(actions.videoReset(value)),
    fullScreen: (value) => dispatch(actions.fullScreen(value)),
    audioMuteToggle: (user, mute) => dispatch(actions.audioMuteToggle(user, mute)),
    clearRemoteVideoUser: () => dispatch(actions.clearRemoteVideoUser())
  }
)

const SeminarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SeminarMode)

export default SeminarContainer



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/SeminarModeContainer.js